interface State {
    isOpen: boolean;
    currentTarget: HTMLElement | null;
}
export default class DropDownMenuHandler {
    private subMenuItem: HTMLElement[];
    public state: State = {
        isOpen: false,
        currentTarget: null,
    };

    constructor() {
        this.subMenuItem = [...document.querySelectorAll<HTMLElement>("[js-submenu-button]")];

        this.init();
    }

    public init = async () => {
        if (!this.subMenuItem) return;

        this.initProxy();

        this.subMenuItem.forEach((item) => {
            this.enableListeners(item);
        });
    };

    public destroy = async () => {
        this.subMenuItem.forEach((item) => {
            this.disablelisteners(item);
        });
    };

    private initProxy = async () => {
        const proxy = new Proxy(this.state, {
            set: (target, prop, value) => {
                if (prop === "currentTarget") target[prop] = value;

                if (prop === "isOpen") {
                    value ? this.openSiblingMenu() : this.closeSiblingMenu();
                    target[prop] = value;
                }

                return true;
            },
        });

        this.state = proxy;
    };

    private menuHandler = ({ currentTarget }: MouseEvent) => {
        const element = currentTarget as HTMLElement;

        this.state.currentTarget = element;
        this.state.isOpen = !this.state.isOpen;
    };

    private declareCurrentElements() {
        const currentElement = this.state.currentTarget as HTMLElement;

        return {
            subMenu: currentElement.querySelector(".my-child-menu__submenu") as HTMLElement,
            listButton: currentElement.querySelector(".my-child-item__button") as HTMLElement,
            parentList: currentElement.closest(".my-child-menu") as HTMLElement,
        };
    }

    private openSiblingMenu = () => {
        const { subMenu, listButton, parentList } = this.declareCurrentElements();

        subMenu.classList.add("sub-menu-open");
        listButton.classList.add("button-active");
        parentList.classList.add("active");
    };

    private closeSiblingMenu = () => {
        const { subMenu, listButton, parentList } = this.declareCurrentElements();

        subMenu.classList.remove("sub-menu-open");
        listButton.classList.remove("button-active");
        parentList.classList.remove("active");
    };

    private enableListeners = (item) => {
        item.addEventListener("mouseenter", this.menuHandler);
        item.addEventListener("mouseleave", this.menuHandler);
    };

    private disablelisteners = (item) => {
        item.removeEventListener("mouseenter", this.menuHandler);
        item.removeEventListener("mouseleave", this.menuHandler);
    };
}
